export class Fleet {
    name: string;
    pto: string;
    fleetType: string;
}